import { Badge } from "./Badge.js";

// Reads VITE_APP_ENV — set in infra/cloudflare.tf per Pages project so
// the admin clearly signals which environment a staff user is signed
// into. Unset (e.g. local dev) renders nothing.
function readEnv(): string {
  return (
    (import.meta as { env?: Record<string, string | undefined> }).env
      ?.VITE_APP_ENV ?? ""
  );
}

export function EnvBadge() {
  const env = readEnv().toLowerCase();
  if (!env || env === "production" || env === "prod") return null;
  // Nonprod / staging / dev / anything else gets a loud badge so an
  // operator never confuses environments at a glance.
  const label = env === "nonprod" ? "Nonprod" : env.toUpperCase();
  return <Badge tone="rose">{label}</Badge>;
}
